import React from 'react';
import PropTypes from 'prop-types';
import { themeShape } from './Player/theme';

export const optionsShape = PropTypes.shape({
  mini: PropTypes.bool,
  restoreFromMiniPlayer: PropTypes.func,
  closeMiniPlayer: PropTypes.func,
  ads: PropTypes.shape({
    logo: PropTypes.string,
    logoWidth: PropTypes.string,
  }),
  felaRenderer: PropTypes.object,

  theme: themeShape,
  language: PropTypes.string,
  messages: PropTypes.object,

  seekStepInSeconds: PropTypes.number,
  controlsHideDelay: PropTypes.number,
  hide: PropTypes.shape({
    fullScreen: PropTypes.bool,
    quality: PropTypes.bool,
    audio: PropTypes.bool,
    cast: PropTypes.bool,
    hideTitle: PropTypes.bool,
    hideBackArrow: PropTypes.bool,
    rating: PropTypes.bool,
  }),
});

export const OptionsContext = React.createContext(null);

export function useOptions() {
  return React.useContext(OptionsContext);
}
